export const capitalizeWordsInString = (str: string) =>
  str
    .split(' ')
    .map(word => capitalizeFirstCharInString(word))
    .join(' ');

export const capitalizeFirstCharInString = (str?: null | string) => (str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '');
